
      const load_time = new Date().getTime();
      const backend = new URL(import.meta.env.VITE_APP_API_ENDPOINT, document.location).origin;

      (() => {
        const link = document.createElement('link');
        link.rel = 'shortcut icon';
        link.href = `${backend}/template-files/favicon.ico`;
        document.head.append(link);
      })();

      window.uwe_template = fetch(`${backend}/template-files/style.json?lt=${load_time}`)
        .then(r => r.json())
        .catch(e => {
          console.error(e);
        });
    